<app-navbar-style-two></app-navbar-style-two>

<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Our Services</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Services</li>
            </ul>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<section class="services-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Our Services</span>
            <h2>We Provide Professional Services</h2>
            <p>Explore our comprehensive range of professional services designed to help your business grow and succeed in the digital age.</p>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="services-filter">
                    <ul>
                        <li *ngFor="let category of categories" 
                            [class.active]="selectedCategory === category"
                            (click)="filterByCategory(category)">
                            {{category}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let service of filteredServices">
                <div class="single-services-box">
                    <div class="image">
                        <img [src]="'assets/img/service/' + service.image" [alt]="service.title">
                    </div>
                    <div class="content">
                        <h3>
                            <a (click)="navigateToService(service.slug)">{{service.title}}</a>
                        </h3>
                        <p>{{service.summary}}</p>
                        <a (click)="navigateToService(service.slug)" class="read-more-btn">
                            Read More <i class="flaticon-right-arrow"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="cta-area">
    <div class="container">
        <div class="cta-inner">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-12">
                    <h2>Ready to get started?</h2>
                    <p>Contact us today to learn more about how our services can help your business grow.</p>
                </div>
                <div class="col-lg-4 col-md-12 text-end">
                    <a routerLink="/contact" class="default-btn">
                        <i class="flaticon-right-arrow"></i>
                        Contact Us
                        <span></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="brand-logo-area pt-100">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo1.png" alt="Images">
                </div>
                
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo2.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo3.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo4.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo5.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo6.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>